var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#224ED1",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0448 36.4776L38.7267 32.7957C39.8698 31.6526 39.9016 29.8093 38.7985 28.6274L32.7932 22.1932C31.6627 20.9819 29.7644 20.9165 28.5531 22.047L25.5885 24.8139C22.2287 27.9498 21.1744 32.8634 23.6445 36.739C26.6601 41.4704 30.8007 46.8068 35.0448 51.5224C38.5408 55.4069 44.6369 60.632 50.0147 64.1479C55.1123 67.4806 60.9781 65.356 64.9668 60.7535L66.0445 59.5101C67.126 58.2622 66.9957 56.375 65.7529 55.2876L58.6495 49.0721C57.4609 48.032 55.6695 48.0917 54.5527 49.2085L50.806 52.9552L35.0448 36.4776Z",
    strokeWidth: 4,
    stroke: "#224ED1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.af23ef2c2f45885c1c0ec0495fde4bac.svg";
export { ForwardRef as ReactComponent };